import React, { Component } from 'react';
import ReactSVG from 'react-svg';
import { Sticky } from 'react-sticky';
import { HeaderStyles } from './HeaderStyles';

class HeaderComponent extends Component {
  render() {
    return (
      <>
        <Sticky>
          {({ style, distanceFromTop }) => (
            <HeaderStyles
              style={style}
              className={
                distanceFromTop < 0 || this.props.whiteBackground
                  ? 'white-background'
                  : ''
              }
            >
              <div className="container-fluid">
                <div className="header-wrap">
                  <div className="logo">
                    {distanceFromTop < 0 || this.props.whiteBackground ? (
                      <ReactSVG src="/static/clientbooks-logo.svg" />
                    ) : (
                      <ReactSVG src="/static/clientbooks-logo-white.svg" />
                    )}
                  </div>
                  <div className="header-right">
                    <div className="phone">
                      <a href="tel:18887490121">1-888-749-0121</a>
                    </div>
                    <a href="/sso/#/login" className="btn btn-primary btn-sm">
                      Sign In
                    </a>
                  </div>
                </div>
              </div>
            </HeaderStyles>
          )}
        </Sticky>
      </>
    );
  }
}

export default HeaderComponent;
